import { IStyle, makeStyles } from '@fluentui/react-theme-provider';
import { linkGreen } from './Shared';

export const useDropdownStyles = () => {
  const container: IStyle = {
    marginTop: 24,
    paddingLeft: 18,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    background: 'transparent',
    borderTop: 0,
    borderRight: 0,
    borderBottom: 0,
    borderLeft: `1px solid ${linkGreen}`,
    color: 'inherit',
    font: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
  };
  const dropDownContent: IStyle = {
    paddingLeft: 18,
  };

  const titleContainer: IStyle = {
    marginBottom: 8,
    fontSize: 18,
    width: '90%',
    ':hover': { cursor: 'pointer' },
  };

  return makeStyles({
    container,
    dropDownContent,
    titleContainer,
  })();
};
